export function documentStatusLabel(status: string): string {
  if (status === "READY") return "Готов";
  if (status === "FAILED") return "Ошибка";
  return "Обработка";
}

export function documentRowStatusLabel(
  status: string,
  progressLabel?: string | null,
): string {
  if (status === "FAILED") return "Ошибка";
  if (progressLabel?.trim() === "В очереди") return "В очереди";
  if (showDocumentIndexBar(progressLabel)) return "Индексация";
  if (status === "READY") return "Готов";
  return "Индексация";
}

export function showDocumentIndexBar(progressLabel?: string | null): boolean {
  const label = progressLabel?.trim();
  return Boolean(label) && label !== "В очереди";
}

export function documentStatusKind(status: string): "green" | "red" | "blue" {
  if (status === "READY") return "green";
  if (status === "FAILED") return "red";
  return "blue";
}

export function parseStatusLabel(status: string): string {
  if (status === "DONE") return "готово";
  if (status === "FAILED") return "ошибка";
  if (status === "PROCESSING") return "разбор";
  return "ожидает";
}
